import { useNavigate } from 'react-router-dom';

export enum ActivitiesTabs {
  Bills = 'bills',
}

export const useActivitiesNavigate = () => {
  const navigate = useNavigate();

  return {
    navigateToTab: ({ tabName }: { tabName: ActivitiesTabs }) => navigate(`/pay-dashboard/${tabName}`),
    navigateToSchedulePayment: ({
      billId,
      returnUrl,
      deliveryMethodId,
    }: {
      billId: string;
      returnUrl?: string;
      deliveryMethodId?: string;
    }) => navigate(`/schedule-payment/${billId}`, { state: { returnUrl, deliveryMethodId } }),
    navigateToBatchPayment: ({ billIds, returnUrl }: { billIds: string[]; returnUrl?: string }) =>
      navigate(`/batch-payments/${billIds.join(',')}`, { state: { returnUrl } }),
    navigateToSettingsPage: () => navigate('/settings'),
    navigateToSettingsSupportPage: () => navigate('/settings/support'),
  };
};
